module.exports = __webpack_public_path__ + "img/sesameeats_2.d685be09.jpg";